export const codeDataArray = [{
    label: {
      en: 'Corporation/Organization Type',
      pt: 'Tipo de Corporação/Organização'
    },
    slug: 'corporations-type'
  },
  {
    label: {
      en: 'Responsible companies',
      pt: 'Empresas responsáveis',
    },
    slug: 'corporations-responsible-organization'
  },
  {
    label: {
      en: 'Commercial Segment',
      pt: 'Segmento Comercial'
    },
    slug: 'segments'
  },
  {
    label: {
      en: 'Project Type',
      pt: 'Tipo de Projeto'
    },
    slug: 'corporations-guideline-project-type'
  },
  {
    label: {
      en: 'Technology Nature',
      pt: 'Natureza da Tecnologia'
    },
    slug: 'corporations-landscape'
  },
  {
    label: {
      en: 'Contact Type',
      pt: 'Tipo de Contato'
    },
    slug: 'corporations-type-contact'
  },
  {
    label: {
      en: 'Extended Attributes',
      pt: 'Atributos Extendidos'
    },
    slug: 'corporations-extended-attribute'
  },
  {
    label: {
      en: 'Procedure Type',
      pt: 'Tipo de procedimento'
    },
    slug: 'corporations-type-procedure'
  },
  {
    label: {
      en: 'Attachment Type',
      pt: 'Tipo de anexo'
    },
    slug: 'corporations-type-attachment'
  },
  {
    label: {
      en: 'Frequency in Analytics',
      pt: 'Frequência em Analíticos'
    },
    slug: 'corporations-type-frequency'
  }
]

export const extendedAttributeArray = [
  { slug: 'data', name: { en: 'Data', pt: 'Data' } },
  { slug: 'decimal', name: { en: 'Decimal', pt: 'Decimal' } },
  { slug: 'integer', name: { en: 'Integer', pt: 'Inteiro' } },
  { slug: 'boolean', name: { en: 'Boolean', pt: 'Sim/Não' } },
  { slug: 'free-text', name: { en: 'Free Text', pt: 'Texto Livre' } },
  { slug: 'restricted-text', name: { en: 'Restricted Text', pt: 'Texto Restrito' } }
]

